module.exports = __webpack_public_path__ + "static/orangeShape-1517a5fcb4d5e6eda5a0c153bcdd58d8.jpg";